import AccessAlarmOutlinedIcon from "@mui/icons-material/AccessAlarmOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import AddIcon from "@mui/icons-material/Add";
import AddLinkIcon from "@mui/icons-material/AddLink";
import ApartmentOutlinedIcon from "@mui/icons-material/ApartmentOutlined";
import ArchitectureIcon from "@mui/icons-material/Architecture";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import AssessmentIcon from "@mui/icons-material/Assessment";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import AssistantOutlinedIcon from "@mui/icons-material/AssistantOutlined";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import AutoModeOutlinedIcon from "@mui/icons-material/AutoModeOutlined";
import BackupTableIcon from "@mui/icons-material/BackupTable";
import BarChartIcon from "@mui/icons-material/BarChart";
import BedIcon from "@mui/icons-material/Bed";
import BookmarkAddOutlinedIcon from "@mui/icons-material/BookmarkAddOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import CachedIcon from "@mui/icons-material/Cached";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CancelIcon from "@mui/icons-material/Cancel";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import CheckIcon from "@mui/icons-material/Check";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import ConstructionIcon from "@mui/icons-material/Construction";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import DangerousOutlinedIcon from "@mui/icons-material/DangerousOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DescriptionIcon from "@mui/icons-material/Description";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import DeveloperBoardIcon from "@mui/icons-material/DeveloperBoard";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadingIcon from "@mui/icons-material/Downloading";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import DrawIcon from "@mui/icons-material/Draw";
import EmergencyIcon from "@mui/icons-material/Emergency";
import EngineeringIcon from "@mui/icons-material/Engineering";
import EventIcon from "@mui/icons-material/Event";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import ExpandIcon from "@mui/icons-material/Expand";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterNoneIcon from "@mui/icons-material/FilterNone";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import FormatSizeIcon from "@mui/icons-material/FormatSize";
import FormatStrikethroughIcon from "@mui/icons-material/FormatStrikethrough";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import ForwardToInboxOutlinedIcon from "@mui/icons-material/ForwardToInboxOutlined";
import FunctionsIcon from "@mui/icons-material/Functions";
import GetAppOutlinedIcon from "@mui/icons-material/GetAppOutlined";
import GridViewSharpIcon from "@mui/icons-material/GridViewSharp";
import GroupsIcon from "@mui/icons-material/Groups";
import HistoryIcon from "@mui/icons-material/History";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import HistoryEduOutlinedIcon from "@mui/icons-material/HistoryEduOutlined";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import ImageIcon from "@mui/icons-material/Image";
import InfoIcon from "@mui/icons-material/Info";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import KeyboardArrowDownOutlined from "@mui/icons-material/KeyboardArrowDownOutlined";
import KeyboardArrowLeftOutlined from "@mui/icons-material/KeyboardArrowLeftOutlined";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";
import KeyboardArrowUpOutlined from "@mui/icons-material/KeyboardArrowUpOutlined";
import LaunchIcon from "@mui/icons-material/Launch";
import LibraryAddCheckOutlinedIcon from "@mui/icons-material/LibraryAddCheckOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import MessageOutlinedIcon from "@mui/icons-material/MessageOutlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MultilineChartIcon from "@mui/icons-material/MultilineChart";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import NotesIcon from "@mui/icons-material/Notes";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ParkIcon from "@mui/icons-material/Park";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import PersonIcon from "@mui/icons-material/Person";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RemoveIcon from "@mui/icons-material/Remove";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import RoomOutlinedIcon from "@mui/icons-material/RoomOutlined";
import RotateLeftOutlinedIcon from "@mui/icons-material/RotateLeftOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ShareIcon from "@mui/icons-material/Share";
import ShortTextIcon from "@mui/icons-material/ShortText";
import StraightenIcon from "@mui/icons-material/Straighten";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import TableViewOutlinedIcon from "@mui/icons-material/TableViewOutlined";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import TitleIcon from "@mui/icons-material/Title";
import TodayIcon from "@mui/icons-material/Today";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import UploadOutlinedIcon from "@mui/icons-material/UploadOutlined";
import ViewListIcon from "@mui/icons-material/ViewList";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

import editIconsvg from "./edit.svg";
import esignDealGraphsvg from "./esign_deal_graph.svg";
import esignDocGraphsvg from "./esign_doc_graph.svg";
import connectedFieldssvg from "./icon_connected_fields.svg";
import connectedFieldsDisabledsvg from "./icon_connected_fields_disabled.svg";
import integrationsIconsvg from "./icon_integrations.svg";
import lockIconsvg from "./lock.svg";
import logoIconsvg from "./logo.svg";
import navMessagesIconsvg from "./nav-messages.svg";
import navMyNotesIconsvg from "./nav-my-notes.svg";
import navTasksIconsvg from "./nav-tasks.svg";
import readyToSubmit from "./ready_to_submit.svg";

const Template = (iconSrc: string) => (props: any) => (
  <img src={iconSrc} alt="" {...props} />
);

const NavMessagesIcon = Template(navMessagesIconsvg);
const NavMyNotesIcon = Template(navMyNotesIconsvg);
const NavTasksIcon = Template(navTasksIconsvg);
const LogoIcon = Template(logoIconsvg);
const LockIcon = Template(lockIconsvg);
const EditIcon = Template(editIconsvg);
const ReadyToSubmit = Template(readyToSubmit);
const ConnectedFieldsIcon = Template(connectedFieldssvg);
const ConnectedFieldsDisabledIcon = Template(connectedFieldsDisabledsvg);
const IntegrationsIcon = Template(integrationsIconsvg);
const EsignDealGraphIcon = Template(esignDealGraphsvg);
const EsignDocGraphIcon = Template(esignDocGraphsvg);

const EditIconSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      clip-rule="evenodd"
      d="M20.4142 8.00003L16 3.58582L6.09701 13.4888L4.62561 19.3744L10.5112 17.903L20.4142 8.00003ZM7.37435 16.6257L7.90294 14.5113L14 8.41425L15.5858 10L9.48873 16.0971L7.37435 16.6257ZM17 8.58582L17.5858 8.00003L16 6.41424L15.4142 7.00003L17 8.58582Z"
    />
  </svg>
);

const AIIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9 5H13" stroke="currentColor" stroke-width="2" />
    <path d="M9 11H13" stroke="currentColor" stroke-width="2" />
    <path d="M11 4V12" stroke="currentColor" stroke-width="2" />
    <path d="M4 9H8" stroke="currentColor" stroke-width="2" />
    <rect
      x="1"
      y="1"
      width="14"
      height="14"
      rx="2"
      stroke="currentColor"
      stroke-width="2"
    />
    <path
      d="M4 12V7C4 5.89543 4.89543 5 6 5V5C7.10457 5 8 5.89543 8 7V12"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
);

export {
  AccessAlarmOutlinedIcon,
  AccessTimeFilledIcon,
  AccessTimeIcon,
  AddIcon,
  AddLinkIcon,
  AIIcon,
  ApartmentOutlinedIcon,
  ArchitectureIcon,
  ArrowBackIcon,
  ArrowBackIosIcon,
  ArrowDownwardIcon,
  ArrowDropDownIcon,
  ArrowForwardIosIcon,
  ArrowForwardOutlinedIcon,
  ArrowRightIcon,
  ArrowUpwardIcon,
  ArticleOutlinedIcon,
  AssessmentIcon,
  AssignmentOutlinedIcon,
  AssistantOutlinedIcon,
  AttachFileIcon,
  AutoAwesomeOutlinedIcon,
  AutoModeOutlinedIcon,
  BackupTableIcon,
  BarChartIcon,
  BedIcon,
  BookmarkAddOutlinedIcon,
  BookmarkBorderOutlinedIcon,
  BorderColorIcon,
  CachedIcon,
  CalendarTodayIcon,
  CancelIcon,
  ChatBubbleOutlineIcon,
  ChatOutlinedIcon,
  CheckCircleIcon,
  CheckCircleOutlineIcon,
  CheckIcon,
  ClearIcon,
  CloseIcon,
  CloudUploadIcon,
  CompareArrowsIcon,
  ConnectedFieldsDisabledIcon,
  ConnectedFieldsIcon,
  ConstructionIcon,
  ContentCopyOutlinedIcon,
  DangerousOutlinedIcon,
  DeleteIcon,
  DeleteOutlineOutlinedIcon,
  DescriptionIcon,
  DescriptionOutlinedIcon,
  DeveloperBoardIcon,
  DisabledByDefaultOutlinedIcon,
  DoneAllIcon,
  DownloadIcon,
  DownloadingIcon,
  DownloadOutlinedIcon,
  DrawIcon,
  EditIcon,
  EditIconSvg,
  EmergencyIcon,
  EngineeringIcon,
  EsignDealGraphIcon,
  EsignDocGraphIcon,
  EventAvailableOutlinedIcon,
  EventIcon,
  ExpandIcon,
  ExpandLess,
  ExpandMore,
  ExpandMoreIcon,
  FileUploadIcon,
  FilterListIcon,
  FilterNoneIcon,
  FolderOpenIcon,
  FormatAlignCenterIcon,
  FormatAlignJustifyIcon,
  FormatAlignLeftIcon,
  FormatAlignRightIcon,
  FormatBoldIcon,
  FormatColorTextIcon,
  FormatItalicIcon,
  FormatListBulletedIcon,
  FormatListNumberedIcon,
  FormatSizeIcon,
  FormatStrikethroughIcon,
  FormatUnderlinedIcon,
  ForumOutlinedIcon,
  ForwardToInboxIcon,
  ForwardToInboxOutlinedIcon,
  FunctionsIcon,
  GetAppOutlinedIcon,
  GridViewSharpIcon,
  GroupsIcon,
  HistoryEduIcon,
  HistoryEduOutlinedIcon,
  HistoryIcon,
  HourglassEmptyIcon,
  ImageIcon,
  InfoIcon,
  InfoOutlinedIcon,
  InsertDriveFileIcon,
  InsertInvitationIcon,
  IntegrationsIcon,
  KeyboardArrowDownOutlined,
  KeyboardArrowLeftOutlined,
  KeyboardArrowRightOutlinedIcon,
  KeyboardArrowUpOutlined,
  LaunchIcon,
  LibraryAddCheckOutlinedIcon,
  LocationOnIcon,
  LockIcon,
  LockOutlinedIcon,
  LogoIcon,
  LogoutIcon,
  ManageAccountsIcon,
  MessageOutlinedIcon,
  ModeEditOutlineOutlinedIcon,
  MoreHorizIcon,
  MoreVertIcon,
  MultilineChartIcon,
  NavMessagesIcon,
  NavMyNotesIcon,
  NavTasksIcon,
  NoteAddOutlinedIcon,
  NotesIcon,
  NotificationsOutlinedIcon,
  OpenInNewIcon,
  ParkIcon,
  PeopleAltOutlinedIcon,
  PersonIcon,
  PersonOutlineOutlinedIcon,
  PlaylistAddIcon,
  PublishOutlinedIcon,
  RadioButtonCheckedIcon,
  RadioButtonUncheckedIcon,
  ReadyToSubmit,
  RemoveCircleIcon,
  RemoveIcon,
  ReportProblemOutlinedIcon,
  RequestQuoteIcon,
  RestartAltIcon,
  RoomOutlinedIcon,
  RotateLeftOutlinedIcon,
  SaveOutlinedIcon,
  SearchIcon,
  SettingsIcon,
  SettingsOutlinedIcon,
  ShareIcon,
  ShortTextIcon,
  StraightenIcon,
  SummarizeIcon,
  SupervisorAccountIcon,
  SupervisorAccountOutlinedIcon,
  TableViewOutlinedIcon,
  TaskOutlinedIcon,
  TitleIcon,
  TodayIcon,
  UnfoldLessIcon,
  UnfoldMoreIcon,
  UploadOutlinedIcon,
  ViewListIcon,
  VisibilityIcon,
  VisibilityOutlinedIcon,
};
